import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import Footer from '../../components/feature/Footer';
import BackToHome from '../../components/feature/BackToHome';
import { fetchDatenschutz, type Datenschutz } from '../../services/datenschutz';
import RevealStagger from '../../components/feature/RevealStagger';
import Seo, { buildBreadcrumbJsonLd } from '../../components/feature/Seo';

export default function DatenschutzPage() {
  const [data, setData] = useState<Datenschutz | null>(null);

  useEffect(() => {
    fetchDatenschutz().then(setData);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAF8F5] via-[#F5F1EB] to-[#FAF8F5]">
      <Seo
        title={`${data?.title || 'Datenschutzerklärung'} | Gerald Fasching`}
        description="Datenschutzerklärung von Gerald Fasching - Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO und österreichischem Datenschutzrecht."
        path="/datenschutz"
        jsonLd={buildBreadcrumbJsonLd([
          { name: 'Start', path: '/' },
          { name: 'Datenschutz', path: '/datenschutz' },
        ])}
      />
      <main className="px-6 pb-20 pt-32">
        <div className="mx-auto max-w-4xl">
          <BackToHome />
          <RevealStagger animateOnMount>
            <h1 className="mb-8 text-[1.625rem] font-bold leading-snug text-[#1A2B3C] md:text-[1.875rem] lg:text-[2.25rem]" style={{ fontFamily: 'Lora, serif' }}>
              {data?.title || 'Datenschutzerklärung'}
            </h1>
          </RevealStagger>

          <div className="space-y-8 rounded-lg bg-white p-8 shadow-sm">
            {data?.sections.map((section, index) => (
              <section key={index}>
                <RevealStagger>
                  <h2 className="mb-4 text-2xl font-bold text-[#1A2B3C]" style={{ fontFamily: 'Lora, serif' }}>
                    {section.title}
                  </h2>
                  <div className="prose prose-sm lg:prose-base prose-gray max-w-none text-gray-700 [&_a]:text-[#8B1538] [&_a:hover]:underline [&_h3]:mt-6 [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:text-[#1A2B3C] [&_p]:leading-relaxed [&_strong]:font-semibold [&_ul]:ml-4 [&_ul]:list-disc [&_ul]:space-y-2">
                    <ReactMarkdown>{section.content}</ReactMarkdown>
                  </div>
                </RevealStagger>
              </section>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
